/*
 * JUNGCARDS spin wheel (snippets/jc-spin-wheel.liquid), replaces the PopConvert popup.
 *
 * JungcardsHQ (app proxy) decides everything that matters:
 *   GET  <endpoint>/config -> { enabled, segments: [{ label_de, label_en, label_fr }] }
 *   POST <endpoint>        -> 200 { prize_index, label, status: "confirm_email" }   (double opt-in:
 *                                    the code is e-mailed once the address is confirmed)
 *                             409 { error: "already_spun", prize_index, label, status: "confirm_email" | "confirmed" }
 *                             (a response that still carries { code, expires } shows the code directly)
 *   POST <endpoint>/resend -> 200 resends the confirmation mail { email, locale }; 404 hides the button
 *                             400 invalid_email | consent_required | invalid, 429 rate_limited,
 *                             403 disabled, 500 internal
 * The wheel only animates to the segment HQ returns. t (ms since the form was shown) and hp
 * (honeypot) are HQ's bot brake.
 *
 * Auto-open: home, collection, search and blog pages only, after the configured delay, never over
 * the cookie banner or another open dialog, not again for 7 days after closing, never after a spin.
 */
(function () {
  var dialog = document.querySelector('[data-jc-spin]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var STORE = 'jc_spin_v1';
  var DISMISS_DAYS = 7;
  var AUTO_TEMPLATES = /^(index|collection|list-collections|search|blog|article)(\.|$)/;

  var endpoint = dialog.dataset.endpoint.replace(/\/$/, '');
  var locale = dialog.dataset.locale || 'de';
  var i18n = JSON.parse(document.querySelector('[data-jc-spin-i18n]').textContent);
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var wheel = dialog.querySelector('[data-jc-spin-wheel]');
  var form = dialog.querySelector('[data-jc-spin-form]');
  var errorEl = dialog.querySelector('[data-jc-spin-error]');
  var submit = dialog.querySelector('[data-jc-spin-submit]');
  var stepForm = dialog.querySelector('[data-jc-spin-step="form"]');
  var stepResult = dialog.querySelector('[data-jc-spin-step="result"]');
  var codeBox = dialog.querySelector('[data-jc-spin-codebox]');
  var pendingBox = dialog.querySelector('[data-jc-spin-pending]');
  var resendButton = dialog.querySelector('[data-jc-spin-resend]');

  var segments = null;
  var configPromise = null;
  var shownAt = 0;
  var angle = 0;
  var idleSpin = null;
  var busy = false;

  function read() {
    try {
      return JSON.parse(localStorage.getItem(STORE)) || {};
    } catch (e) {
      return {};
    }
  }

  function write(value) {
    try {
      localStorage.setItem(STORE, JSON.stringify(value));
    } catch (e) {}
  }

  function label(segment) {
    return segment['label_' + locale] || segment.label_de || '';
  }

  /* "15 % Rabatt ab 40 €" -> ["15 %", "ab 40 €"], "€5 off orders €30+" -> ["€5", "orders €30+"] */
  function splitLabel(text) {
    var match = text.match(/^(\d+\s?%|€\s?\d+|\d+\s?€)\s*(.*)$/);
    if (!match) return [text, ''];
    return [match[1], match[2].replace(/^(Rabatt|off|de réduction)\s*/i, '').trim()];
  }

  /* ---- Wheel drawing (SVG, 0° = top, clockwise; segment i is centred at i * step) ---- */
  function point(radius, degrees) {
    var rad = (degrees * Math.PI) / 180;
    return (radius * Math.sin(rad)).toFixed(2) + ' ' + (-radius * Math.cos(rad)).toFixed(2);
  }

  function svgEl(name, attrs) {
    var el = document.createElementNS('http://www.w3.org/2000/svg', name);
    for (var key in attrs) el.setAttribute(key, attrs[key]);
    return el;
  }

  function draw() {
    var count = segments.length;
    var step = 360 / count;
    var radius = 146;
    wheel.textContent = '';
    wheel.appendChild(svgEl('circle', { r: 158, class: 'jc-spin__rim' }));
    for (var i = 0; i < count; i++) {
      var start = i * step - step / 2;
      var end = start + step;
      wheel.appendChild(
        svgEl('path', {
          d: 'M0 0 L' + point(radius, start) + ' A' + radius + ' ' + radius + ' 0 0 1 ' + point(radius, end) + ' Z',
          class: 'jc-spin__seg jc-spin__seg--' + (i % 2 ? 'b' : 'a'),
        })
      );
      var parts = splitLabel(label(segments[i]));
      var group = svgEl('g', { transform: 'rotate(' + i * step + ')' });
      /* tangential labels: the winning segment reads upright under the pointer */
      var text = svgEl('text', {
        transform: 'translate(0 ' + (parts[1] ? -104 : -96) + ')',
        class: 'jc-spin__label jc-spin__label--' + (i % 2 ? 'b' : 'a'),
        'text-anchor': 'middle',
      });
      var big = svgEl('tspan', { x: 0, dy: 0, class: 'jc-spin__label-big' });
      big.textContent = parts[0];
      text.appendChild(big);
      if (parts[1]) {
        var small = svgEl('tspan', { x: 0, dy: 17, class: 'jc-spin__label-small' });
        small.textContent = parts[1];
        text.appendChild(small);
      }
      group.appendChild(text);
      wheel.appendChild(group);
    }
    for (var b = 0; b < 16; b++) {
      var pos = point(152, b * 22.5).split(' ');
      wheel.appendChild(svgEl('circle', { cx: pos[0], cy: pos[1], r: 3.2, class: 'jc-spin__bulb jc-spin__bulb--' + (b % 2) }));
    }
  }

  function loadConfig() {
    if (!configPromise) {
      configPromise = fetch(endpoint + '/config', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (config) {
          if (!config || !config.enabled || !config.segments || config.segments.length < 2) return false;
          segments = config.segments;
          draw();
          return true;
        })
        .catch(function () {
          return false;
        });
    }
    return configPromise;
  }

  /* ---- Spinning ---- */
  function currentAngle() {
    var transform = getComputedStyle(wheel).transform;
    if (!transform || transform === 'none') return angle;
    var matrix = new DOMMatrixReadOnly(transform);
    return (Math.atan2(matrix.b, matrix.a) * 180) / Math.PI;
  }

  function setAngle(value) {
    angle = value;
    wheel.style.transform = 'rotate(' + value + 'deg)';
  }

  function startIdleSpin() {
    if (reduceMotion || !wheel.animate) return;
    idleSpin = wheel.animate([{ transform: 'rotate(' + angle + 'deg)' }, { transform: 'rotate(' + (angle + 360) + 'deg)' }], {
      duration: 650,
      iterations: Infinity,
    });
  }

  function stopIdleSpin() {
    if (!idleSpin) return;
    var now = currentAngle();
    idleSpin.cancel();
    idleSpin = null;
    setAngle(now);
  }

  function landOn(index) {
    var step = 360 / segments.length;
    var from = idleSpin ? currentAngle() : angle;
    stopIdleSpin();
    var target = -(index * step) + (Math.random() - 0.5) * step * 0.6;
    var delta = (((target - from) % 360) + 360) % 360;
    var to = from + 360 * 5 + delta;
    if (reduceMotion || !wheel.animate) {
      setAngle(to);
      return Promise.resolve();
    }
    return new Promise(function (resolve) {
      var spin = wheel.animate([{ transform: 'rotate(' + from + 'deg)' }, { transform: 'rotate(' + to + 'deg)' }], {
        duration: 4800,
        easing: 'cubic-bezier(0.12, 0.8, 0.18, 1)',
        fill: 'forwards',
      });
      spin.onfinish = function () {
        setAngle(to);
        spin.cancel();
        resolve();
      };
    });
  }

  function sparks() {
    if (reduceMotion) return;
    var box = dialog.querySelector('[data-jc-spin-sparks]');
    box.textContent = '';
    for (var i = 0; i < 22; i++) {
      var spark = document.createElement('span');
      var direction = (i / 22) * Math.PI * 2;
      var distance = 90 + Math.random() * 90;
      spark.style.setProperty('--x', Math.cos(direction) * distance + 'px');
      spark.style.setProperty('--y', Math.sin(direction) * distance + 'px');
      spark.style.animationDelay = Math.random() * 120 + 'ms';
      box.appendChild(spark);
    }
    setTimeout(function () {
      box.textContent = '';
    }, 1600);
  }

  /* ---- Form & result ---- */
  function showError(message, field) {
    errorEl.textContent = message;
    errorEl.hidden = false;
    if (field) {
      field.setAttribute('aria-invalid', 'true');
      field.focus();
    }
  }

  function clearError() {
    errorEl.hidden = true;
    errorEl.textContent = '';
    form.querySelectorAll('[aria-invalid]').forEach(function (el) {
      el.removeAttribute('aria-invalid');
    });
  }

  function setBusy(state) {
    busy = state;
    submit.disabled = state;
    submit.textContent = state ? i18n.spinning : i18n.submit;
    dialog.classList.toggle('is-spinning', state);
  }

  function formatDate(iso) {
    var date = new Date(iso);
    if (isNaN(date)) return '';
    return date.toLocaleDateString(locale === 'en' ? 'en-GB' : locale, { day: 'numeric', month: 'long', year: 'numeric' });
  }

  /* snap: reopening with a saved code shows the won segment without an animation */
  function showResult(data, again, snap) {
    write({ code: data.code, label: data.label, expires: data.expires, prize_index: data.prize_index });
    codeBox.hidden = false;
    pendingBox.hidden = true;
    dialog.querySelector('[data-jc-spin-result-eyebrow]').textContent = again ? i18n.again_eyebrow : i18n.win_eyebrow;
    dialog.querySelector('[data-jc-spin-prize]').textContent = i18n.win_title.replace('[prize]', data.label);
    dialog.querySelector('[data-jc-spin-code]').textContent = data.code;
    var until = formatDate(data.expires);
    var valid = dialog.querySelector('[data-jc-spin-valid]');
    valid.textContent = until ? i18n.valid_until.replace('[date]', until) : '';
    valid.hidden = !until;
    dialog.querySelector('[data-jc-spin-apply]').href =
      '/discount/' + encodeURIComponent(data.code) + '?redirect=' + encodeURIComponent(location.pathname + location.search);
    stepForm.hidden = true;
    stepResult.hidden = false;
    dialog.classList.add('is-won');
    if (snap && typeof data.prize_index === 'number' && segments) setAngle(-(data.prize_index * (360 / segments.length)));
    dialog.querySelector('[data-jc-spin-prize]').focus();
  }

  /* Prize won, the code follows by e-mail after the double opt-in confirmation */
  function showPending(data, again, snap, email) {
    var confirmed = data.status === 'confirmed' || data.confirmed === true;
    write({ pending: true, confirmed: confirmed, label: data.label, prize_index: data.prize_index, email: email || '' });
    dialog.querySelector('[data-jc-spin-result-eyebrow]').textContent = again ? i18n.again_eyebrow : i18n.win_eyebrow;
    dialog.querySelector('[data-jc-spin-prize]').textContent = i18n.win_title.replace('[prize]', data.label);
    dialog.querySelector('[data-jc-spin-pending-title]').textContent = confirmed ? i18n.confirmed_title : i18n.pending_title;
    var text = i18n.pending_text_noemail;
    if (confirmed) text = i18n.confirmed_text;
    else if (email) text = i18n.pending_text.replace('[email]', email);
    dialog.querySelector('[data-jc-spin-pending-text]').textContent = text;
    dialog.querySelector('[data-jc-spin-spam]').hidden = confirmed;
    resendButton.hidden = confirmed || !email;
    resendButton.disabled = false;
    resendButton.textContent = i18n.resend;
    codeBox.hidden = true;
    pendingBox.hidden = false;
    stepForm.hidden = true;
    stepResult.hidden = false;
    dialog.classList.add('is-won');
    if (snap && typeof data.prize_index === 'number' && segments) setAngle(-(data.prize_index * (360 / segments.length)));
    dialog.querySelector('[data-jc-spin-prize]').focus();
  }

  resendButton.addEventListener('click', function () {
    var email = read().email;
    if (!email) return;
    resendButton.disabled = true;
    fetch(endpoint + '/resend', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ email: email, locale: locale }),
    })
      .then(function (response) {
        if (response.ok) {
          resendButton.textContent = i18n.resent;
        } else if (response.status === 404) {
          resendButton.hidden = true;
        } else {
          resendButton.disabled = false;
          resendButton.textContent = response.status === 429 ? i18n.error_rate : i18n.error_generic;
        }
      })
      .catch(function () {
        resendButton.disabled = false;
      });
  });

  dialog.querySelector('[data-jc-spin-done]').addEventListener('click', function () {
    dialog.close();
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (busy) return;
    clearError();
    var email = form.elements.email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return showError(i18n.error_email, form.elements.email);
    if (!form.elements.consent.checked) return showError(i18n.error_consent, form.elements.consent);

    setBusy(true);
    startIdleSpin();
    var minimumSpin = new Promise(function (resolve) {
      setTimeout(resolve, reduceMotion ? 0 : 1100);
    });
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        email: email,
        first_name: form.elements.first_name.value.trim() || undefined,
        locale: locale,
        consent: true,
        t: Date.now() - shownAt,
        hp: form.elements.website.value,
      }),
    })
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            return minimumSpin.then(function () {
              return { status: response.status, data: data };
            });
          });
      })
      .then(function (result) {
        var data = result.data || {};
        if ((result.status === 200 || result.status === 409) && typeof data.prize_index === 'number') {
          return landOn(data.prize_index).then(function () {
            setBusy(false);
            if (result.status === 200) sparks();
            if (data.code) showResult(data, result.status === 409, false);
            else showPending(data, result.status === 409, false, email);
          });
        }
        stopIdleSpin();
        setBusy(false);
        if (data.error === 'invalid_email') showError(i18n.error_email, form.elements.email);
        else if (data.error === 'consent_required') showError(i18n.error_consent, form.elements.consent);
        else if (data.error === 'rate_limited') showError(i18n.error_rate);
        else if (data.error === 'disabled') dialog.close();
        else showError(i18n.error_generic);
      })
      .catch(function () {
        stopIdleSpin();
        setBusy(false);
        showError(i18n.error_generic);
      });
  });

  dialog.querySelector('[data-jc-spin-copy]').addEventListener('click', function (event) {
    var button = event.currentTarget;
    var code = dialog.querySelector('[data-jc-spin-code]').textContent;
    var done = function () {
      button.textContent = i18n.copied;
      setTimeout(function () {
        button.textContent = i18n.copy;
      }, 1800);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, function () {});
  });

  /* ---- Open / close ---- */
  function open() {
    loadConfig().then(function (ok) {
      if (!ok || dialog.open) return;
      var saved = read();
      if (saved.code) showResult(saved, true, true);
      else if (saved.pending) showPending(saved, true, true, saved.email);
      dialog.showModal();
      shownAt = Date.now();
      document.documentElement.classList.add('jc-spin-open');
      if (!saved.code && !saved.pending) form.elements.email.focus({ preventScroll: true });
    });
  }

  dialog.addEventListener('close', function () {
    document.documentElement.classList.remove('jc-spin-open');
    var saved = read();
    if (!saved.code && !saved.pending) write({ dismissed: Date.now() });
  });

  dialog.querySelector('[data-jc-spin-close]').addEventListener('click', function () {
    dialog.close();
  });

  /* click on the backdrop (the dialog box itself, outside the panel) closes */
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog && !busy) dialog.close();
  });

  dialog.addEventListener('cancel', function (event) {
    if (busy) event.preventDefault();
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-jc-spin-open]');
    if (!trigger) return;
    event.preventDefault();
    open();
  });

  /* ---- Auto-open ---- */
  function bannerVisible() {
    var banner = document.getElementById('shopify-pc__banner');
    return banner && banner.offsetParent !== null && getComputedStyle(banner).display !== 'none';
  }

  function otherOverlayOpen() {
    return (
      document.querySelector('dialog[open]:not([data-jc-spin]), details[open] > .menu-drawer, .drawer.active') ||
      document.body.classList.contains('overflow-hidden-tablet') ||
      document.body.classList.contains('overflow-hidden')
    );
  }

  function dismissedRecently() {
    var dismissed = read().dismissed;
    return dismissed && Date.now() - dismissed < DISMISS_DAYS * 864e5;
  }

  if (dialog.dataset.auto === 'true' && AUTO_TEMPLATES.test(dialog.dataset.template) && !read().code && !read().pending && !dismissedRecently()) {
    var delay = (parseInt(dialog.dataset.delay, 10) || 20) * 1000;
    var tryOpen = function () {
      if (dialog.open || dismissedRecently() || read().code || read().pending) return;
      if (bannerVisible() || otherOverlayOpen() || document.hidden) {
        setTimeout(tryOpen, 5000);
        return;
      }
      open();
    };
    setTimeout(function () {
      loadConfig();
    }, Math.max(0, delay - 4000));
    setTimeout(tryOpen, delay);
  }
})();
